import React from 'react';
import TextArea from './TextArea';
import TextInputField from './TextInputField';
import ImageField from './ImageField';
import { commonFieldTypes } from './field.config';
import DropDown from './DropDown';
import MediaUploadField from './mediaUploadField';

export default function FieldTypeSelector(props) {
  const { fieldType } = props.config;

  // switch case for fieldType
  const renderField = () => {
    switch (fieldType) {
      case commonFieldTypes.text:
        return <TextInputField {...props} />;
      case commonFieldTypes.textarea:
        return <TextArea {...props} />;
      case commonFieldTypes.image:
        return <ImageField {...props} />;
      case commonFieldTypes.dropdown:
        return <DropDown {...props} />;
      case commonFieldTypes.media:
        return <MediaUploadField {...props} />;
      default:
        return <>{fieldType}</>;
    }
  };

  return <>{renderField()}</>;
}
